import * as React from "react";
import { IReduxState } from "reducers";
import { Link } from "react-router";
import { connect } from "react-redux";
import "./styles.scss";
import {imageBaseUrl} from "config";

interface IConnectProps {
  dispatch?: (action: any) => void;
  email: string;
  pathname: string;
}

class ChatAppBar extends React.Component<IConnectProps, {}> {

  public render() {
    return (
      <div className="navbar navbar-default navbar-fixed-top navbar-light bg-light">
        <Link className="navbar-brand" to="/">
          <img src={`${imageBaseUrl}/img/logo/logo-row.svg`} style={{ width: 175, margin:8 }} />
        </Link>
        {!this.props.email && <a href="https://mv343.app.goo.gl/mtck"
          target="_blank"><img style={{ width: 150 }} src={`${imageBaseUrl}/img/playstore.png`} /></a>}
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
  return {
    email: state.login.auth ? state.login.auth.email : null,
    pathname: state.router.location.pathname,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(ChatAppBar);
